export default __webpack_public_path__ + "static/media/noticePdg.ff567b35.svg";